// morgens-hub web — belépési pont
// architektúra: apps/web/CLAUDE.md
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Két font, két munka — mindkettő self-hosted (nincs külső kérés, nincs FOUT-villanás):
//  · Space Grotesk: a Morgens brand geometrikus hangja — felület, navigáció, címek.
//  · Literata: a cikk-törzsé. Kifejezetten hosszú képernyős olvasásra tervezték, és a Hubon a
//    valódi munka 4000 karakteres cikkek végigolvasása, nem a gombok nézegetése.
// Változó-súlyú (variable) verziók: egy fájl minden súlyra, kevesebb kérés.
import '@fontsource-variable/space-grotesk';
import '@fontsource-variable/literata';
import '@fontsource-variable/jetbrains-mono';

import { routeTree } from './routeTree.gen';

import { RouteError } from '@/components/shared/route-error';

import './styles/globals.css';

// Audit T15: enélkül egy render-hiba a routeren üres fehér oldalt ad, kiút nélkül — a
// `defaultErrorComponent` minden route-ra vonatkozik, amíg az adott route nem ad sajátot.
const router = createRouter({ routeTree, defaultErrorComponent: RouteError });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('#root not found');

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
